import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function AngelAdvantage() {
  return <section className="py-14 md:py-20 bg-light-gold relative overflow-hidden" data-id="element-23">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-24">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border-[20px] border-gold" data-id="element-25"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full border-[20px] border-gold" data-id="element-26"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-28">
          <div className="bg-navy p-10 text-center" data-id="element-29">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-gold mb-4" data-id="element-30">
              PRESENTANDO LA VENTAJA ANGEL
            </h2>
          </div>

          <div className="p-8 md:p-12 space-y-8 text-lg md:text-xl text-gray-800" data-id="element-31">
            <div className="space-y-4 font-bold text-navy text-xl md:text-2xl text-center" data-id="element-32">
              <p data-id="element-33">Angel Insurance no es un número 1-800.</p>
              <p data-id="element-34">Angel Insurance no es un chatbot.</p>
            </div>

            <div className="bg-off-white p-6 rounded-xl border border-gold/30 flex items-start gap-4" data-id="element-35">
              <MapPin className="text-gold shrink-0 mt-1" size={28} data-id="element-36" />
              <p data-id="element-37">
                <strong data-id="element-38">
                  Angel Insurance es una oficina real, con personas reales, aquí
                  mismo en Tampa
                </strong>{' '}
                — en el 3840 W Humphrey St — lista para sentarse contigo y hacer
                esto simple.
              </p>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            ease: 'easeOut'
          }} className="my-10" data-id="element-39">
              <div className="relative rounded-2xl overflow-hidden border border-gold/40 shadow-xl" data-id="element-40">
                <img src="https://cdn.magicpatterns.com/uploads/ncsnjnsc4hakGkGVRtPaHg/fOTO_BELLA_DE_ANGEL_INSURANCE.png" alt="Fundadores de Angel Insurance" className="w-full h-auto object-cover max-h-[450px]" data-id="element-41" />
              </div>
              <p className="text-center text-sm md:text-base text-gray-500 mt-4 italic" data-id="element-42">
                Los fundadores de Angel Insurance — aquí para ti, aquí en Tampa.
              </p>
            </motion.div>

            <ul className="space-y-4 pl-4 border-l-4 border-gold py-2" data-id="element-43">
              <li data-id="element-44">
                Creemos que los seguros deben sentirse como una conversación, no
                como un contrato.
              </li>
              <li data-id="element-45">
                Creemos que mereces entender exactamente por qué estás pagando.
              </li>
              <li data-id="element-46">
                Creemos que proteger a tu familia no debería requerir un título
                universitario.
              </li>
            </ul>

            <p className="text-2xl font-serif font-bold text-center text-navy pt-4" data-id="element-47">
              Por eso construimos algo diferente.
            </p>

            <p className="text-center bg-light-gold/30 p-6 rounded-lg italic" data-id="element-48">
              Una agencia donde nos tomamos el tiempo — todo el tiempo que
              necesites — para explicarte tus opciones, explicar todo en
              lenguaje sencillo (en inglés o español), y construir un plan de
              cobertura que realmente se ajuste a tu vida. Tu presupuesto. Tu
              familia.
            </p>

            <div className="flex flex-wrap justify-center gap-4 font-bold text-navy uppercase tracking-wider text-sm md:text-base pt-4" data-id="element-49">
              <span className="bg-gray-100 px-4 py-2 rounded-full" data-id="element-50">
                Sin presión
              </span>
              <span className="bg-gray-100 px-4 py-2 rounded-full" data-id="element-51">
                Sin jerga técnica
              </span>
              <span className="bg-gray-100 px-4 py-2 rounded-full" data-id="element-52">
                Sin desaparecer después de la venta
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}